import { memo } from 'react'
import { locales } from '../../../../locales/en'
import type { IconProps } from '../../../Icons'
import Trending from '../../../Icons/Trending'
import { palette } from '../../../styles/colors'
import Container from '../Container'

interface PopularBadgeProps extends IconProps {
    shadow?: boolean
    size?: number
}

const PopularBadge = memo((props: PopularBadgeProps) => {
    const { shadow, size = 0.8, ...other } = props

    return (
        <Container title="Popular" shadow={shadow}>
            <Trending
                title={locales.settings.pinToTop.popular}
                color={palette.badgePopular}
                size={size}
                {...other}
            />
        </Container>
    )
})

export default PopularBadge
export { PopularBadge }
